// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"05d1037d","455":"83d893c6","977":"c6070a55"}[chunkId] + ".chunk.js";
};